<script>
	export default {
		components: {},
	};
</script>

<template>
	<div class="container">
		<div class="mt-3 my-sm-5">
			<slot />
		</div>
	</div>
</template>
<style scoped>
	.my-3 {
		margin-block: 12px;
	}
</style>
